<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-3">
          <h4 v-html="data.testResultLogin.testResultsHeader"></h4>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-lg col-middle">
          <div v-html="data.testResultLogin.testResultsText"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <button class="btn btn-primary btn-md btn-login" style="min-width: 150px" @click="$router.push('/login-cnfrm')">
            {{ data.testResultLogin.testResultsLoginBtn }}
          </button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'

export default {
  name: 'logintestresult',
  components: {},
  data () {
    return {
      data: null,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          testResultLogin(locale: ` + sessionStorage.getItem('language') + `) {
            testResultsHeader
            testResultsText
            personalNumberLabel
            testResultsLoginBtn
          }
        }
      `
    })
    setTimeout(() => { window.scrollTo(0, 0) })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:disabled {
  opacity: 0.3;
}
.img-bankid {
  width: 2vw;
}
.container {
  padding-bottom: 3vh;
}
.col-middle {
  margin: 2vh auto 3vh auto;
  max-width: 48vw;
  border-radius: 10px;
  background: #90c981;
  padding: 4vh 10vw 2vh 10vw;
  color: #3c552b;
}
.btn-login {
  margin-top: 1vh;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .col-middle {
    margin-top: 3vh;
    margin-bottom: 3vh;
    max-width: 90vw;
    background: #90c981;
    padding: 2vh 5vw 1vh 5vw;
    color: #47743b;
  }
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login_TestResult.vue